import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../config/Translate";
import TextField from "@material-ui/core/TextField/TextField";
import axios from "axios";
import {defaultVariabls} from "../../../config/index";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import LoadingButton from "../../components/elements/LoadingButton";
import Grid from "@material-ui/core/Grid/Grid";
import {connect, setStore} from "trim-redux";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {Step, StepContent, StepLabel, Stepper} from "@material-ui/core";
import Button from "@material-ui/core/Button/Button";
import Rating from "@material-ui/lab/Rating/Rating";
import FieldCounterWithoutBar from "../../components/elements/FieldCounterWithoutBar";
import AppCardLoaderFields from "../../components/Skeletons/AppCardLoaderFields";
import CheckBoxTwoToneIcon from '@material-ui/icons/CheckBoxTwoTone';
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Switch from "@material-ui/core/Switch/Switch";
import Alert from "@material-ui/lab/Alert/Alert";
import GetConfirmationText from "../../components/elements/GetConfirmationText";
class WriteReview extends React.Component {

    state = {
        fields:{
            publish_rate:4.5,
            publish_description:'',
            translate_rate:4.5,
            translate_description:'',
            print_rate:4.5,
            print_description:'',
            pack_rate:4.5,
            pack_description:'',
            vendor_rate:4.5,
            vendor_description:'',
            description:'',
        },
        product:null,
        errors:{},
        loading: true,
        SubmitLoading: false,
        confirmed: true,
        product_id:this.props.product_id,
        editMode:false,
        review_submitted:false,
        activeStep:0,
        review_id:this.props.review_id,
        manage:this.props.manage,
    };
    classes = this.props.classes;
    async componentDidMount(){
        await this.setState({
            product_id:this.props.product_id,
        })
        if(this.props.review_id === 0){
            this.setState({
                loading:false,
            })
        }else{
            await this.loadData();
        }
    }
    async loadData(){
        let {review_id} = this.state;
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/review/get/${review_id}`, config)
                .then(response => {
                    this.setState({
                        fields: {
                            publish_rate: response.data.publish_rate,
                            publish_description: !!response.data.publish_description ? response.data.publish_description : '',
                            translate_rate:response.data.translate_rate,
                            translate_description:!!response.data.translate_description ? response.data.translate_description : '',
                            print_rate:response.data.print_rate,
                            print_description:!!response.data.print_description ? response.data.print_description : '',
                            pack_rate:response.data.pack_rate,
                            pack_description:!!response.data.pack_description ? response.data.pack_description : '',
                            vendor_rate:response.data.vendor_rate,
                            vendor_description:!!response.data.vendor_description ? response.data.vendor_description : '',
                            description:!!response.data.description ? response.data.description : '',
                        },
                        editMode:true,
                        loading:false,
                        confirmed: response.data.confirmed,
                    })
                }).catch(error => {
                    console.log(error.response);
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    handleChange(e){
        let {errors,fields} = this.state;
        let target = e.target;
        fields[target.name] = target.value;
        errors[target.name] = "";

        this.setState({
            fields,
            errors,
        });
    }

    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;
        if(fields.publish_description !== null ) {
            if (fields.publish_description.length > 150) {
                formIsValid = false;
                errors['publish_description'] = Translate.maxLength150;
            }
        }
        if(fields.translate_description !== null ) {
            if (fields.translate_description.length > 150) {
                formIsValid = false;
                errors['translate_description'] = Translate.maxLength150;
            }
        }
        if(fields.pack_description !== null ) {
            if (fields.pack_description.length > 150) {
                formIsValid = false;
                errors['pack_description'] = Translate.maxLength150;
            }
        }
        if(fields.print_description !== null ) {
            if (fields.print_description.length > 150) {
                formIsValid = false;
                errors['print_description'] = Translate.maxLength150;
            }
        }
        if(fields.vendor_description !== null ) {
            if (fields.vendor_description.length > 150) {
                formIsValid = false;
                errors['vendor_description'] = Translate.maxLength150;
            }
        }
        if(fields.description !== null ) {
            if (fields.description.length > 500) {
                formIsValid = false;
                errors['description'] = Translate.maxLength500;
            }
        }
        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                errors,
                SubmitLoading:false,
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        let {user} = this.props;
        if(!user.last_name || !user.first_name){
            this.props.enqueueSnackbar(Translate.pleaseCompleteYourInfoFirst, {
                variant: 'error',
            });
            return false
        }else{
            let { fields,product_id,confirmed,editMode,review_id} = this.state;
            let data = new FormData();
            data.append('publish_rate', fields.publish_rate);
            data.append('publish_description', fields.publish_description);
            data.append('translate_rate', fields.translate_rate);
            data.append('translate_description', fields.translate_description);
            data.append('print_rate', fields.print_rate);
            data.append('print_description', fields.print_description);
            data.append('pack_rate', fields.pack_rate);
            data.append('pack_description', fields.pack_description);
            data.append('vendor_rate', fields.vendor_rate);
            data.append('vendor_description', fields.vendor_description);
            data.append('description', fields.description);
            data.append('product_id', product_id);
            data.append('id', review_id);
            data.append('confirmed',  confirmed ? 1 : 0);

            let loginToken = localStorage.getItem('ACT');
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            axios.post(`${defaultVariabls.url}/review/make`, data, config)
                .then(response => {
                    this.props.enqueueSnackbar(editMode ? Translate.reviewEdited : Translate.reviewAdded, {
                        variant: 'success',
                    });
                    this.setState({
                        loading:false,
                        SubmitLoading: false,
                        review_submitted:!this.state.manage,
                    });
                })
                .catch(error => {
                    console.log(error.response)
                    this.props.enqueueSnackbar(editMode ?  Translate.dataEditingFailed : Translate.dataAddingFailed, {
                        variant: 'error',
                    });
                    this.setState({
                        loading:false,
                        SubmitLoading: false,
                        SubmitDraftLoading: false
                    });
                });
        }
    }

    handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }

    handleChangeConfirmed(){
        this.setState({
            confirmed: !this.state.confirmed,
        })
    }

    handleDelete(){
        let {review_id} = this.state;
        let data = new FormData();
        data.append('id',  review_id);
        this.setState({
            loading: false
        });
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/review/delete`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.deleteReview, {
                    variant: 'success',
                });
                this.props.history.push('/manage/reviews')
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.deleteReviewFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
            });
    }
    handleBack(){
        this.setState({
            activeStep:this.state.activeStep - 1
        })
    }
    handleNext(){
        this.setState({
            activeStep:this.state.activeStep + 1
        })
    }
    handleChangeRating(val,position){
        let {fields} = this.state;
        fields[position] = val;
        this.setState({
            fields
        })
    }
    render(){
        let {fields,activeStep, errors,SubmitLoading,loading,review_submitted,manage,confirmed} = this.state;
        return (
            <>
                {
                    loading ?
                        <AppCardLoaderFields/>
                        :
                        <>
                            {
                               !!manage &&
                                <Grid container spacing={2}>
                                    <Grid item xs={10}>
                                        <Alert
                                            severity="info"
                                            action={
                                                <FormControlLabel
                                                    style={{marginRight:10,color: !confirmed ? "#ed1d1d" : ""}}
                                                    control={
                                                        <Switch
                                                            checked={confirmed}
                                                            onChange={this.handleChangeConfirmed.bind(this)}
                                                            value={confirmed}
                                                            color="primary"
                                                        />
                                                    }
                                                    label={confirmed ? Translate.confirmed : Translate.unConfirmed}
                                                />
                                            }
                                        >
                                            {Translate.confirmationStatusDescription}
                                        </Alert>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <LoadingButton
                                            styleForParent={{margin:0,marginBottom:5}}
                                            style={{width:"100%"}}
                                            variant="contained"
                                            color="primary"
                                            loading={SubmitLoading}
                                            onClick={this.handleSubmit.bind(this)}
                                        >
                                            {Translate.save}
                                        </LoadingButton>
                                        <GetConfirmationText
                                            variant="outlined"
                                            style={{color: "#f44336",width:"100%",backgroundColor:"#fff"}}
                                            tooltip={Translate.removeReview}
                                            handleAction={() => this.handleDelete()}
                                        >
                                            {Translate.removeReview}
                                        </GetConfirmationText>
                                    </Grid>
                                </Grid>
                            }
                            {
                                review_submitted ?
                                    <>
                                        <div className="review_submitted">
                                            <CheckBoxTwoToneIcon/>
                                            <h3>{Translate.review_submitted}</h3>
                                            <p>{Translate.review_submitted_text}</p>
                                        </div>
                                    </>
                                    :
                                    <Stepper activeStep={activeStep} orientation="vertical">
                                        <Step>
                                            <StepLabel>{Translate.publish_quality}</StepLabel>
                                            <StepContent>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <Rating
                                                            name="publish_rate"
                                                            precision={0.5}
                                                            value={fields.publish_rate}
                                                            onChange={(event, newValue) => {
                                                                this.handleChangeRating(newValue,'publish_rate')
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            variant="outlined"
                                                            multiline
                                                            fullWidth
                                                            name="publish_description"
                                                            label={Translate.description}
                                                            type="text"
                                                            minRows="2"
                                                            value={fields.publish_description}
                                                            onChange={this.handleChange.bind(this)}
                                                            error={!!errors['publish_description']}
                                                            helperText={errors['publish_description']}
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <FieldCounterWithoutBar length={fields.publish_description.length} max={150}/>
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Button
                                                            disabled={activeStep === 0}
                                                            onClick={() => this.handleBack()}
                                                        >
                                                            {Translate.back}
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() => this.handleNext()}
                                                        >
                                                            {Translate.nextLevel}
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </StepContent>
                                        </Step>
                                        <Step>
                                            <StepLabel>{Translate.translate_quality}</StepLabel>
                                            <StepContent>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <Rating
                                                            name="translate_rate"
                                                            precision={0.5}
                                                            value={fields.translate_rate}
                                                            onChange={(event, newValue) => {
                                                                this.handleChangeRating(newValue,'translate_rate')
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            variant="outlined"
                                                            multiline
                                                            fullWidth
                                                            name="translate_description"
                                                            label={Translate.description}
                                                            type="text"
                                                            minRows="2"
                                                            value={fields.translate_description}
                                                            onChange={this.handleChange.bind(this)}
                                                            error={!!errors['translate_description']}
                                                            helperText={errors['translate_description']}
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <FieldCounterWithoutBar length={fields.translate_description.length} max={150}/>
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Button
                                                            disabled={activeStep === 0}
                                                            onClick={() => this.handleBack()}
                                                        >
                                                            {Translate.back}
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() => this.handleNext()}
                                                        >
                                                            {Translate.nextLevel}
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </StepContent>
                                        </Step>
                                        <Step>
                                            <StepLabel>{Translate.print_quality}</StepLabel>
                                            <StepContent>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <Rating
                                                            name="print_rate"
                                                            precision={0.5}
                                                            value={fields.print_rate}
                                                            onChange={(event, newValue) => {
                                                                this.handleChangeRating(newValue,'print_rate')
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            variant="outlined"
                                                            multiline
                                                            fullWidth
                                                            name="print_description"
                                                            label={Translate.description}
                                                            type="text"
                                                            minRows="2"
                                                            value={fields.print_description}
                                                            onChange={this.handleChange.bind(this)}
                                                            error={!!errors['print_description']}
                                                            helperText={errors['print_description']}
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <FieldCounterWithoutBar length={fields.print_description.length} max={150}/>
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Button
                                                            disabled={activeStep === 0}
                                                            onClick={() => this.handleBack()}
                                                        >
                                                            {Translate.back}
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() => this.handleNext()}
                                                        >
                                                            {Translate.nextLevel}
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </StepContent>
                                        </Step>
                                        <Step>
                                            <StepLabel>{Translate.pack_quality}</StepLabel>
                                            <StepContent>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <Rating
                                                            name="pack_rate"
                                                            precision={0.5}
                                                            value={fields.pack_rate}
                                                            onChange={(event, newValue) => {
                                                                this.handleChangeRating(newValue,'pack_rate')
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            variant="outlined"
                                                            multiline
                                                            fullWidth
                                                            name="pack_description"
                                                            label={Translate.description}
                                                            type="text"
                                                            minRows="2"
                                                            value={fields.pack_description}
                                                            onChange={this.handleChange.bind(this)}
                                                            error={!!errors['pack_description']}
                                                            helperText={errors['pack_description']}
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <FieldCounterWithoutBar length={fields.pack_description.length} max={150}/>
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Button
                                                            disabled={activeStep === 0}
                                                            onClick={() => this.handleBack()}
                                                        >
                                                            {Translate.back}
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() => this.handleNext()}
                                                        >
                                                            {Translate.nextLevel}
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </StepContent>
                                        </Step>
                                        <Step>
                                            <StepLabel>{Translate.vendor_quality}</StepLabel>
                                            <StepContent>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <Rating
                                                            name="vendor_rate"
                                                            precision={0.5}
                                                            value={fields.vendor_rate}
                                                            onChange={(event, newValue) => {
                                                                this.handleChangeRating(newValue,'vendor_rate')
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            variant="outlined"
                                                            multiline
                                                            fullWidth
                                                            name="vendor_description"
                                                            label={Translate.description}
                                                            type="text"
                                                            minRows="2"
                                                            value={fields.vendor_description}
                                                            onChange={this.handleChange.bind(this)}
                                                            error={!!errors['vendor_description']}
                                                            helperText={errors['vendor_description']}
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <FieldCounterWithoutBar length={fields.vendor_description.length} max={150}/>
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Button
                                                            disabled={activeStep === 0}
                                                            onClick={() => this.handleBack()}
                                                        >
                                                            {Translate.back}
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() => this.handleNext()}
                                                        >
                                                            {Translate.nextLevel}
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </StepContent>
                                        </Step>
                                        <Step>
                                            <StepLabel>{Translate.submit_review_title}</StepLabel>
                                            <StepContent>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            variant="outlined"
                                                            multiline
                                                            fullWidth
                                                            name="description"
                                                            label={Translate.overalDescription}
                                                            type="text"
                                                            minRows="4"
                                                            value={fields.description}
                                                            onChange={this.handleChange.bind(this)}
                                                            error={!!errors['description']}
                                                            helperText={errors['description']}
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <FieldCounterWithoutBar length={fields.description.length} max={500}/>
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Button
                                                            disabled={activeStep === 0}
                                                            onClick={() => this.handleBack()}
                                                        >
                                                            {Translate.back}
                                                        </Button>
                                                        <LoadingButton
                                                            variant="contained"
                                                            color="primary"
                                                            loading={SubmitLoading}
                                                            onClick={this.handleSubmit.bind(this)}
                                                        >
                                                            {Translate.submit_review}
                                                        </LoadingButton>
                                                    </Grid>
                                                </Grid>
                                            </StepContent>
                                        </Step>
                                    </Stepper>
                            }
                        </>
                }
            </>

        );
    }
}

const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withWidth()(withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(WriteReview)))));